export default __webpack_public_path__ + "static/media/card_destaque.c521fd60.jpg";